/**
 * Central Textbooks Content Registry
 */

import * as ifrs from './IFRS';

export { ifrs };

export const allTextbooks = {
  IFRS: ifrs
};

export const getAllTextbookConfigs = () =>
  Object.values(allTextbooks).map((textbook) => textbook.config);

export const getTextbookConfigById = (textbookId) =>
  allTextbooks[textbookId]?.config || null;

export const getTextbookChaptersById = (textbookId) =>
  allTextbooks[textbookId]?.chapters || [];

export const getTextbookIds = () => Object.keys(allTextbooks);

export default allTextbooks;
